<script>
import { Line } from "vue-chartjs";

import zoomPlugin from "chartjs-plugin-zoom";
export default {
  name: "LineChart",
  extends: Line,
  props: {
    valuesList: Array,
    timestamps: Array,
    UomArray: Array,
    showByDate: Boolean
  },

  watch: {
    valuesList: function() {
      this.$data._chart.destroy();
      this.chartData.labels = this.timestamps;
      this.setupChartLines();
      this.renderLineChart();
    },
    showByDate: function() {
      if (this.showByDate) {
        this.typeTimeHolder = {
          type: "time"
        };
      } else {
        this.typeTimeHolder = {};
      }
      this.renderChart(this.chartData, {
        ...this.options,
        tooltips: {
          mode: "index",
          intersect: false
        },
        hover: {
          mode: "index",
          intersect: false
        },
        responsive: true,
        onClick: this.handle,

        maintainAspectRatio: false,
        scales: {
          yAxes: [...this.yAxes],
          xAxes: [this.typeTimeHolder]
        }
      });
    }
  },
  data() {
    return {
      gradient: null,
      gradient2: null,
      addedTimes: [],
      values: [],
      graphLineColor: "",
      borderColors: ["#e57373", "#64b5f6", "#81c784", "#263238", "#1accbe"],
      pointBackgroundColors: [
        "#af4448",
        "#2286c3",
        "#519657",
        "#263238",
        "#1accbe"
      ],
      pointBorderColor: ["#af4448", "#2286c3", "#519657", "#263238", "#1accbe"],
      theLabels: this.timestamps,
      yAxes: [],
      chartData: {
        labels: this.timestamps,
        datasets: []
      },
      typeTimeHolder: {},
      options: {
        pointStyle: "rect",

        pan: {
          enabled: true,
          mode: "x"
        },
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: "x"
            },
            zoom: {
              enabled: true,
              // drag: true,
              mode: "x"
            }
          }
        },
        tooltips: {
          mode: "index",
          intersect: false
        },
        hover: {
          mode: "index",
          intersect: false
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.handle
      }
    };
  },
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
    this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
    this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");
    this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
    this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.5)");
    this.gradient2.addColorStop(1, "rgba(0, 231, 255, 0.3)");
    this.addPlugin({
      // draw vertical line on hover
      afterDatasetsDraw: function(chart) {
        if (chart.tooltip._active && chart.tooltip._active.length) {
          var activePoint = chart.tooltip._active[0],
            ctx = chart.ctx,
            y_axis = chart.scales["y-axis-0"],
            x = activePoint.tooltipPosition().x,
            topY = 32,
            bottomY = 277;
          ctx.save();
          ctx.beginPath();
          ctx.moveTo(x, topY);
          ctx.lineTo(x, bottomY);
          ctx.lineWidth = 2;
          ctx.strokeStyle = "#263238";
          ctx.stroke();
          ctx.restore();
        }
      }
    });
    this.addPlugin(zoomPlugin);

    this.populateValues();
    this.renderLineChart();
  },
  computed: {},
  methods: {
    renderLineChart(chartData = this.chartData) {
      this.renderChart(chartData, {
        ...this.options,
        scales: {
          yAxes: [...this.yAxes],
          xAxes: [this.typeTimeHolder]
        }
      });
    },
    populateValues() {
      this.setupChartLines();
      this.setupUomAxes();
    },
    setupChartLines() {
      class ChartLine {
        constructor(
          type,
          label,
          borderColor,
          pointBackgroundColors,
          borderWidth,
          pointBorderColor,
          pointRadius,
          fill,
          data,
          yAxisID
        ) {
          this.label = label;
          this.borderColor = borderColor;
          this.pointBackgroundColor = pointBackgroundColors;
          this.borderWidth = borderWidth;
          this.pointBorderColor = pointBorderColor;
          this.pointRadius = pointRadius;
          this.fill = fill;
          this.data = data;
          this.yAxisID = yAxisID;
          this.pointStyle = "rect";
          this.radius = 1;
        }
      }
      let graphColorIndex = 0;
      this.chartData.datasets = [];

      for (let i = 0; i < this.valuesList.length; i++) {
        for (let x = 0; x < this.valuesList[i].valueList.length; x++) {
          let val = new ChartLine(
            "line",
            this.valuesList[i].valueNames[x],
            this.borderColors[graphColorIndex],
            this.pointBackgroundColors[graphColorIndex],
            1,
            this.pointBorderColor[graphColorIndex],
            5,
            false,
            this.valuesList[i].valueList[x],
            i
          );

          this.chartData.datasets.push(val);

          graphColorIndex++;
        }
      }
    },
    setupUomAxes() {
      class UomAxes {
        constructor(id, labelStringValue, position = "left") {
          this.id = id;
          this.scaleLabel = {
            display: true,
            labelString: labelStringValue
          };
          this.ticks = {
            beginAtZero: false
          };
        }
      }
      for (let i = 0; i < this.valuesList.length; i++) {
        let uom;
        uom = new UomAxes(i, this.UomArray[i]);

        if (i != 0) {
          uom.position = "right";
        }
        this.yAxes.push(uom);
      }
    }
  }
};
</script>
